import LayoutComponent from '../BaseScreen';
import IntellachatPage from './IntellachatPage';

const IntellachatScreen = () => {
  return (
    <LayoutComponent
      header={null}
      content={
        <div className="w-full h-full flex flex-col">
          <IntellachatPage />
        </div>
      }
    />
  );
};

export default IntellachatScreen;
